import { useEffect } from 'react';

export function useJsonLd(json: Record<string, unknown>) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(json);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [json]);
}